import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import GameScreen from './components/GameScreen';
import MenuScreen from './components/MenuScreen';
import ShopScreen from './components/ShopScreen';
import ProfileScreen from './components/ProfileScreen';
import { GameProvider } from './context/GameContext';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('menu');

  return (
    <GameProvider>
      <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100">
        <Router>
          <Routes>
            <Route path="/" element={
              <AnimatePresence mode="wait">
                {currentScreen === 'menu' && (
                  <motion.div
                    key="menu"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <MenuScreen onNavigate={setCurrentScreen} />
                  </motion.div>
                )}
                {currentScreen === 'game' && (
                  <motion.div
                    key="game"
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <GameScreen onNavigate={setCurrentScreen} />
                  </motion.div>
                )}
                {currentScreen === 'shop' && (
                  <motion.div
                    key="shop"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ShopScreen onNavigate={setCurrentScreen} />
                  </motion.div>
                )}
                {currentScreen === 'profile' && (
                  <motion.div
                    key="profile"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ProfileScreen onNavigate={setCurrentScreen} />
                  </motion.div>
                )}
              </AnimatePresence>
            } />
          </Routes>
        </Router>
      </div>
    </GameProvider>
  );
}

export default App;